export default {
	attributes: {
		design: 'basic',
		columns: 2,
		imageSize: 'large',
		image1Id: 583,
		image1FullWidth: 1920,
		image1FullHeight: 1277,
		image2Id: 467,
		image2FullWidth: 640,
		image2FullHeight: 853,
		image1Url: 'https://source.unsplash.com/400x300/?shoes',
		image1FullUrl: 'https://source.unsplash.com/400x300/?fashion',
		image2Url: 'https://source.unsplash.com/400x300/?apparel',
		image2FullUrl: 'https://source.unsplash.com/400x300/?accessory',
		showOverlay: true,
		overlayBackgroundColor: '#107a76',
		overlayBackgroundCustomSizeUnit: '%',
		overlayTabletBackgroundCustomSizeUnit: '%',
		overlayMobileBackgroundCustomSizeUnit: '%',
		overlayOpacity: 0.5,
		showOverlayHover: true,
		overlayHoverBackgroundColor: '#107a76',
		overlayHoverBackgroundCustomSizeUnit: '%',
		overlayHoverTabletBackgroundCustomSizeUnit: '%',
		overlayHoverMobileBackgroundCustomSizeUnit: '%',
		overlayHoverOpacity: 0.7,
		subtitle1: 'Subtitle',
		subtitle2: 'Subtitle',
		showSubtitle: true,
		subtitleLineHeightUnit: 'em',
		subtitleTabletLineHeightUnit: 'em',
		subtitleMobileLineHeightUnit: 'em',
		title1: 'Title',
		title2: 'Title',
		showTitle: true,
		titleLineHeightUnit: 'em',
		titleTabletLineHeightUnit: 'em',
		titleMobileLineHeightUnit: 'em',
		description1: 'Description',
		description2: 'Description',
		showDescription: true,
		descriptionLineHeightUnit: 'em',
		descriptionTabletLineHeightUnit: 'em',
		descriptionMobileLineHeightUnit: 'em',
		showArrow: false,
		uniqueClass: 'ugb-a6dea13',
		hideDesktop: false,
		hideTablet: false,
		hideMobile: false,
		showBlockBackground: false,
		blockBackgroundBackgroundCustomSizeUnit: '%',
		blockBackgroundTabletBackgroundCustomSizeUnit: '%',
		blockBackgroundMobileBackgroundCustomSizeUnit: '%',
		topSeparatorDesign: 'wave-1',
		bottomSeparatorDesign: 'wave-1',
		topSeparatorShadow: true,
		bottomSeparatorShadow: true,
		showBlockTitle: false,
		blockTitleLineHeightUnit: 'em',
		blockTitleTabletLineHeightUnit: 'em',
		blockTitleMobileLineHeightUnit: 'em',
		showBlockDescription: false,
		blockDescriptionLineHeightUnit: 'em',
		blockDescriptionTabletLineHeightUnit: 'em',
		blockDescriptionMobileLineHeightUnit: 'em',
	},
}
